import SamplePointStatistic, { RainSummary } from 'types/models/samplePointsStatistic';
import { convertMetricToImperialAlwaysRounding } from 'utils/convert-metric-to-imperial';
import { UnitType } from 'utils/get-unit-by-country';
import { assertIsSamplePointStatisticWithAggregates } from 'utils/SamplePointStatistics/assert-is-with-aggregates';

export const getRainSummary = (
  statistic: SamplePointStatistic,
  country: string
): RainSummary | undefined => {
  try {
    assertIsSamplePointStatisticWithAggregates(statistic);
  } catch (error) {
    // Do nothing. Data is not as expected to compute the intended summary.
    return;
  }

  const { aggregates } = statistic;
  const rawToday: number | undefined = aggregates.today?.values?.sum ?? undefined;
  const rawMtd: number | undefined = aggregates.mtd?.values?.sum ?? undefined;
  const rawYtd: number | undefined = aggregates.ytd?.values?.sum ?? undefined;
  const rawRoll90D: number | undefined = aggregates.rolling90Days?.values?.sum ?? undefined;
  const rawRoll12M: number | undefined = aggregates.rolling12Months?.values?.sum ?? undefined;

  const today: number | undefined = convertMetricToImperialAlwaysRounding(UnitType.RAIN, country, rawToday);
  const mtd: number | undefined = convertMetricToImperialAlwaysRounding(UnitType.RAIN, country, rawMtd);
  const ytd: number | undefined = convertMetricToImperialAlwaysRounding(UnitType.RAIN, country, rawYtd);
  const rolling90Days: number | undefined = convertMetricToImperialAlwaysRounding(UnitType.RAIN, country, rawRoll90D);
  const rolling12Months: number | undefined = convertMetricToImperialAlwaysRounding(UnitType.RAIN, country, rawRoll12M);

  return {
    today: today ?? null,
    mtd: mtd ?? null,
    ytd: ytd ?? null,
    rolling90Days: rolling90Days ?? null,
    rolling12Months: rolling12Months ?? null,
    wetDaysYtd: aggregates.wetDaysYtd?.values?.sum ?? null
  };
};
